var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMydashboardSharedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 0.25C4.275 0.25 2.25 2.275 2.25 4.75C2.25 6.238 2.98275 7.5625 4.10175 8.383C2.124 9.364 0.75 11.398 0.75 13.75H2.25C2.25 11.257 4.257 9.25 6.75 9.25C9.243 9.25 11.25 11.257 11.25 13.75H12.75C12.75 11.257 14.757 9.25 17.25 9.25C19.743 9.25 21.75 11.257 21.75 13.75H23.25C23.25 11.3973 21.876 9.364 19.8983 8.383C20.4709 7.96574 20.937 7.41929 21.2588 6.78803C21.5805 6.15678 21.7488 5.45852 21.75 4.75C21.75 2.275 19.725 0.25 17.25 0.25C14.775 0.25 12.75 2.275 12.75 4.75C12.75 6.238 13.4827 7.5625 14.6017 8.383C13.5059 8.92176 12.5989 9.77963 12 10.8438C11.4011 9.77963 10.4941 8.92176 9.39825 8.383C9.97088 7.96574 10.437 7.41929 10.7588 6.78803C11.0805 6.15678 11.2488 5.45852 11.25 4.75C11.25 2.275 9.225 0.25 6.75 0.25ZM6.75 1.75C8.41725 1.75 9.75 3.08275 9.75 4.75C9.75 6.41725 8.41725 7.75 6.75 7.75C5.08275 7.75 3.75 6.41725 3.75 4.75C3.75 3.08275 5.08275 1.75 6.75 1.75ZM17.25 1.75C18.9172 1.75 20.25 3.08275 20.25 4.75C20.25 6.41725 18.9172 7.75 17.25 7.75C15.5828 7.75 14.25 6.41725 14.25 4.75C14.25 3.08275 15.5828 1.75 17.25 1.75Z",
    fill: "#4C5157"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMydashboardSharedIcon);
export default __webpack_public_path__ + "static/media/mydashboard_shared_icon.1faf28df297019e383b7f425d9c1bfa6.svg";
export { ForwardRef as ReactComponent };